import { gql } from "apollo-boost"

export const CREATE_PROJECT_MONTHS_STATUS_ROWS = gql`
    mutation CreateAllProjectMonthsStatus($submissionId: ID!) {
        CreateProjectMonthStatusRows(submissionId: $submissionId )
    }
`
